import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from 'material-ui/Dialog';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import RequestInformationButton from '../../OfferOverview/RequestInformationButton';

import { required, TextField } from 'entoro-shared';

const OfferPwdForm = reduxForm({
  form: 'offerPwdForm',
  enableReinitialize: true,
})(
  ({
    handleSubmit,
    submitting,
    request,
    title,
    handleClose,
    submitText,
    offerId,
  }) => (
    <form onSubmit={handleSubmit(request)}>
      <DialogTitle className='text-target-raise'>
        <IconButton aria-label='lock'>
          <SvgIcon style={{ fontSize: 30 }}>
            <path d='M17.308,7.564h-1.993c0-2.929-2.385-5.314-5.314-5.314S4.686,4.635,4.686,7.564H2.693c-0.244,0-0.443,0.2-0.443,0.443v9.3c0,0.243,0.199,0.442,0.443,0.442h14.615c0.243,0,0.442-0.199,0.442-0.442v-9.3C17.75,7.764,17.551,7.564,17.308,7.564 M10,3.136c2.442,0,4.43,1.986,4.43,4.428H5.571C5.571,5.122,7.558,3.136,10,3.136 M16.865,16.864H3.136V8.45h13.729V16.864z M10,10.664c-0.854,0-1.55,0.696-1.55,1.551c0,0.699,0.467,1.292,1.107,1.485v0.95c0,0.243,0.2,0.442,0.443,0.442s0.443-0.199,0.443-0.442V13.7c0.64-0.193,1.106-0.786,1.106-1.485C11.55,11.36,10.854,10.664,10,10.664 M10,12.878c-0.366,0-0.664-0.298-0.664-0.663c0-0.366,0.298-0.665,0.664-0.665c0.365,0,0.664,0.299,0.664,0.665C10.664,12.58,10.365,12.878,10,12.878' />
          </SvgIcon>
        </IconButton>
        <span style={{ color: 'red' }}> {title}</span>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <DialogContentText>
              This offer is password protected. Please enter the password.{' '}
              <br /> If you would like to access this offer, please contact the
              banker. <br />{' '}
              <RequestInformationButton offerId={offerId} linkForm={true} />
            </DialogContentText>
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='offerPassword'
              type='password'
              autoComplete='offerPassword'
              label='Enter Offer Password'
              required
            />
            <br />
            <br />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={submitting}
          onClick={handleClose}
          className='action-button cancel'
          disableRipple
        >
          Cancel
        </Button>
        <Button
          type='submit'
          disabled={submitting}
          className='action-button'
          disableRipple
        >
          {submitting ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={15} color='inherit' />
              &nbsp;
              {submitText}
            </div>
          ) : (
            submitText
          )}
        </Button>
      </DialogActions>
    </form>
  )
);

const mapStateToProps = ({ investorUser = {} }, { offerId }) => {
  const { kycStatus, offerPassword } = investorUser;

  return {
    kycStatus,
    initialValues: {
      offerId,
      offerPassword,
    },
  };
};

export default connect(mapStateToProps)(OfferPwdForm);



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferPwd/OfferPwdForm.js